export default __webpack_public_path__ + "static/media/file_00001 (3).9d864daa.pdf";